import * as qs from 'query-string';
import AnalyticsService from '../services/analyticsService';
import trimEnd from 'lodash/trimEnd';

export function isExternalUrl(url, location) {
    return ((url.indexOf(':') > -1 || url.indexOf('//') > -1 ) && checkDomain(location.href, location) !== checkDomain(url));
}

function checkDomain(url, location) {
    if (url.indexOf('//') === 0) { 
        url = location.protocol + url;
    }
    return url.toLowerCase().replace(/([a-z])?:\/\//,'$1').split('/')[0];
}
  
export function isSoundCloudRedirect(location) {
    const queryStrings = qs.parse(location.search);
    return queryStrings.returnUrl && trimEnd(queryStrings.returnUrl, '/') === '/Profile/Manage/HearMe';
}

export function isAccountSettingsRedirect(location) {
    const queryStrings = qs.parse(location.search);
    return queryStrings.returnUrl && trimEnd(queryStrings.returnUrl, '/') === '/Account/Settings';
}

export function logExternalLinkClick(event) {
    const link = event.target.getAttribute('href');
    AnalyticsService.logEventGA('ExternalLink', 'Clicked', link);
    AnalyticsService.logEventBing('ExternalLink', 'Clicked', link);
    AnalyticsService.logEventFB('ExternalLink-' + link);
}